import Link from 'next/link'
import React, { FC, useMemo } from 'react'
import s from './MenuLink.module.sass'

import { Text } from '@shared/ui/Typography/Text'
import IconDaily from '@icons/icon-afisha-daily.svg'
import IconDots from '@icons/icon-three-dots.svg'
import IconClose from '@icons/icon--x-big.svg'
import { EGG } from '@shared/api/analytics'
import { LoadingSpinner } from '@shared/ui/Feedback/LoadingSpinner'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

interface Props {
  link?: string
  text?: string
  selected?: boolean
  daily?: boolean
  dots?: boolean
  close?: boolean
  button?: boolean
  dataId: string | number
  className?: string
}

const MenuLink: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLButtonElement>, HTMLButtonElement>> = ({
  link,
  text,
  selected,
  daily,
  dots,
  close,
  button,
  dataId,
  className,
  ...props
}) => {
  const isLink = Boolean(text && link)
  const isDaily = Boolean(daily && link)
  const isDots = Boolean(dots)
  const isButton = Boolean(button && text)
  const isClose = Boolean(close)

  const getClasses = useMemo(() => {
    return `${s.link} ${selected ? s.selected : ''} ${isDaily ? s.daily : ''} ${isDots ? s.dots : ''} ${
      isClose ? s.close : ''
    } ${className || ''}`
  }, [selected, isDaily, isDots, className])

  const handleClick = () => {
    EGG.header.button_tab_click({ navigation_name: isLink ? text : isDaily ? 'Daily' : '' })
  }

  const responsive = useClientResponsive()
  const { isMobile } = responsive

  const hasLoading = typeof props['data-loading'] === 'boolean'
  const loadingState = hasLoading ? props['data-loading'] : null
  // hasLoading && console.log('!!! MenuLink: loadingState', loadingState)

  return (
    <>
      {isLink && (
        // @ts-ignore
        <Link href={link} className={getClasses} onClick={handleClick} data-id={dataId} scroll={false} {...props}>
          <Text tag='span' sizes='S' uppercase>
            {text}
          </Text>
        </Link>
      )}

      {isDaily && (
        // @ts-ignore
        <Link href={link} className={getClasses} onClick={handleClick} data-id={dataId} scroll={false} {...props}>
          <IconDaily className={s['daily-icon']} />
        </Link>
      )}

      {(isDots || isClose) && (
        <button className={getClasses} data-id={dataId} {...props}>
          {isDots && <IconDots />}
          {isClose && <IconClose />}
        </button>
      )}

      {isButton && (
        <button className={getClasses} data-id={dataId} {...props}>
          {hasLoading && <LoadingSpinner loading={loadingState} size={isMobile ? 20 : 24} iconColor='#000' />}

          {loadingState === false && (
            <Text tag='span' sizes='S' uppercase>
              {text}
            </Text>
          )}
        </button>
      )}
    </>
  )
}

export default MenuLink
